import { Link } from "react-router-dom";
import { AppRoutes } from "../../../config";
import { Box, Popover, styled, Typography } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import TravelExploreOutlinedIcon from "@mui/icons-material/TravelExploreOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import useAuthorization from "../../../contexts/useAuthorization";

interface MobileMenuProps {
  isMenuOpen: boolean;
  handleMenuClose: () => void;
  anchorEl: HTMLElement | null;
}

export const MobileMenu = ({ isMenuOpen, handleMenuClose, anchorEl }: MobileMenuProps) => {
  const { loggedIn, isGuardian, isPioneer } = useAuthorization();

  // Upload is a guardian capability, so Pioneers get it too (see useAuthorization).
  const menuItems = [
    { icon: HomeOutlinedIcon, label: "Home", path: AppRoutes.EcoBank.path, show: true },
    { icon: TravelExploreOutlinedIcon, label: "Explore", path: AppRoutes.Explore.path, show: true },
    { icon: UploadFileIcon, label: "Upload", path: AppRoutes.Upload.path, show: loggedIn && (isGuardian || isPioneer) },
    {
      icon: PersonOutlineOutlinedIcon,
      label: "Account",
      path: AppRoutes.Profile.subRoutes.Dashboard.path,
      show: loggedIn,
    },
    {
      icon: SettingsOutlinedIcon,
      label: "Settings",
      path: AppRoutes.Profile.subRoutes.Identification.path,
      show: loggedIn,
    },
    { icon: InfoOutlinedIcon, label: "Help Center", path: AppRoutes.About.path, show: true },
  ];

  return (
    <Popover
      open={isMenuOpen}
      anchorEl={anchorEl}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      disableScrollLock
      PaperProps={{
        elevation: 0,
        sx: {
          mt: "10px",
          borderRadius: "14px",
          border: "1px solid rgba(0,0,0,0.08)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          minWidth: "220px",
          overflow: "hidden",
          p: "6px",
        },
      }}
    >
      <MenuList>
        {menuItems
          .filter(({ show }) => show)
          .map(({ icon: Icon, label, path }) => (
            <MenuItem key={label} onClick={handleMenuClose} to={path}>
              <Icon sx={{ width: "20px", height: "20px", color: "#111" }} />
              <MenuLabel>{label}</MenuLabel>
            </MenuItem>
          ))}
      </MenuList>
    </Popover>
  );
};

const MenuList = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const MenuItem = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  color: #111;
  transition: background-color 0.12s ease;

  &:hover {
    background-color: #f5f5f5;
  }
`;

const MenuLabel = styled(Typography)`
  font-size: 15px;
  font-weight: 500;
  color: #111;
  letter-spacing: -0.01em;
`;
